export default "<p fxFlex fxLayoutAlign=\"center center\">Nenhum resultado foi encontrado.</p>\r\n"